import { IScheduleTaskAttributeRateKey } from '../../interfaces/ischedule-task-attribute-rate-key';
import { ItemRate } from '../item-rate';
import { ResourceCalculation } from '../resource-calculation';
import { ScheduleTaskAttribute } from '../schedule-task-attribute';

export class ScheduleTaskAttributeRateKeyBase {
  ScheduleTaskAttributeRateKeyId: number;
  ScheduleTaskAttributeId: number;
  ItemRateId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ResourceCalculationId: number | null;

  ItemRate?: ItemRate;
  ResourceCalculation?: ResourceCalculation;
  ScheduleTaskAttribute?: ScheduleTaskAttribute;

  constructor(item?: IScheduleTaskAttributeRateKey) {
    if (item) {

      this.ScheduleTaskAttributeRateKeyId = item.ScheduleTaskAttributeRateKeyId;
      this.ScheduleTaskAttributeId = item.ScheduleTaskAttributeId;
      this.ItemRateId = item.ItemRateId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ResourceCalculationId = item.ResourceCalculationId;

      this.ItemRate = new ItemRate(item.ItemRate);
      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
      this.ScheduleTaskAttribute = new ScheduleTaskAttribute(item.ScheduleTaskAttribute);
    }
  }
}